<ng-container *ngIf="appNotice$ | async as notice">
  <ng-container
    *ngIf="notice.name === 'annual_plans_reminder'; else standardAppNotice">
    <ng-container *ngIf="!billingRoute">
      <ng-container *ngIf="(hideAnnualReminder$ | async) === false">
        <div
          *ngIf="notice.persistent"
          class="alert alert-{{ notice.type }}">
          <i class="icon-alert-{{ notice.icon }}"></i>

          <a
            class="alert-close"
            (click)="hideAnnualReminder()"></a>

          <core-app-notice-message
            [appNotice]="notice"
            [agency]="context.agency | async"
            [company]="context.company | async"
            [user]="context.user | async"
            [withMockLinks]="true"
            [withMessageVariant]="true">
          </core-app-notice-message>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-template #standardAppNotice>
    <div
      *ngIf="notice.persistent"
      class="alert alert-{{ notice.type }}">
      <i class="icon-alert-{{ notice.icon }}"></i>

      <a
        *ngIf="notice.dismissible"
        class="alert-close"
        (click)="dismiss(notice)"></a>

      <core-app-notice-message
        [appNotice]="notice"
        [agency]="context.agency | async"
        [company]="context.company | async"
        [user]="context.user | async"
        [withMockLinks]="true"
        [withMessageVariant]="false">
      </core-app-notice-message>
    </div>
  </ng-template>
</ng-container>

<ng-container *ngIf="clientReload.notification$ | async as notice">
  <div class="alert alert-{{ notice.type }}">
    <i class="icon-alert-{{ notice.icon }}"></i>
    Your account was updated
    <ui-time-ago [timestamp]="notice.created_at"></ui-time-ago>. Please
    <a (click)="clientReload.reload()">reload this page</a>.
  </div>
</ng-container>
